export default __webpack_public_path__ + "static/media/Artboard 20 2.2e3504f7.svg";